module.exports = __webpack_public_path__ + "img/msc.aeef8ef7.jpeg";